"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Groups = exports.NAMESPACE = void 0;
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy';
/**
 * Documentation-only contracts for the v2 routes still served by Express.
 *
 * Each module under this directory exports one or more `HttpApiGroup` values
 * describing legacy routes (method, path, parameters, bodies, responses,
 * security) without any handler. Register every group here so it becomes part
 * of `V2.Spec.Complete` and, through its `Audience` annotation, of the
 * filtered documents.
 *
 * Nothing in this registry is ever served: `V2.Spec.Spec` stays the runtime
 * contract implemented by the unified-api handlers.
 */
exports.Groups = [];
//# sourceMappingURL=index.js.map